exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-modal .ant-modal-content {\n  background-color: transparent;\n  border-radius: 0;\n}", ""]);

// exports
